const VALIDATION_ERRORS = [
  {
    code: "invalid_amount",
    status_code: "400",
    pointer: ["expires"],
    translations: {
      title: {
        en: "Check passed amount",
        ru: "Проверьте правильность данных",
        uk: "Перевірте корректність даних",
      },
      details: {
        en: "Amount must be correct",
        ru: "Проверьте правильность данных",
        uk: "Перевірте корректність даних",
      },
    },
  },
  {
    code: "api_client_error",
    status_code: "403",
    translations: {
      title: {
        en: "API client error on application initialization",
        ru: "Ошибка при инициализации АПИ клиента",
        uk: "Помилка при ініціалізації АПІ кліента",
      },
      details: {
        en: "Please try again later",
        ru: "Попробуйте позже",
        uk: "Спробуйте пізніше",
      },
    },
  },
  {
    code: "api_client_network_error",
    status_code: "503",
    translations: {
      title: {
        en: "Network or API error.",
        ru: "Ошибка сети или не отвечает сервер.",
        uk: "Помилка зв'язку з сервером",
      },
      details: {
        en: "Please try again later",
        ru: "Попробуйте позже",
        uk: "Спробуйте пізніше",
      },
    },
  },

  {
    code: "unsupported_currency",
    status_code: "400",
    translations: {
      title: {
        en: "The passed currency is not supported",
        ru: "Валюта не поддерживается вашим аккаунтом.",
        uk: "Валюта не підтримується вашим аккаунтом.",
      },
      details: {
        en: "Check currency.",
        ru: "Проверьте валюту в настройках вашего аккаунта",
        uk: "Перевірте валюту",
      },
    },
  },


  {
    code: "no_payload",
    status_code: "403",
    pointer: ["expires"],
    translations: {
      title: {
        en: "Processing error",
        ru: "Ошибка при проведении оплаты",
        uk: "Помилка при проведені оплати",
      },
      details: {
        en: "Cannot process",
        ru: "Нельзя провести оплату, попробуйте позже",
        uk: "Спробуйте пізніше",
      },
    },
  },

  {
    code: "401",
    status_code: "401",
    icon_source: "@/assets/403.svg",
    pointer: ["expires"],
    translations: {
      title: {
        en: "Auth error",
        ru: "Ошибка авторизации",
        uk: "Auth error",
      },
      details: {
        en: "Check the API key",
        ru: "Проверьте АПИ ключ",
        uk: "Check the API key",
      },
    },
  },

  {
    code: "invalid_date",
    status_code: "400",
    pointer: ["expires"],
    translations: {
      title: {
        en: "Check passed expiration date",
        ru: "Проверьте правильность данных",
        uk: "Перевірте корректність даних",
      },
      details: {
        en: "Check passed expiration date",
        ru: "Проверьте правильность данных",
        uk: "Перевірте корректність даних",
      },
    },
  },
  {
    code: "date_expired",
    status_code: "400",
    pointer: ["expires"],
    translations: {
      title: {
        en: "Time is out",
        ru: "Время вышло",
        uk: "Час скінчився",
      },
      details: {
        en: "Time is out",
        ru: "Время вышло",
        uk: "Час скінчився",
      },
    },
  },

  {
    code: "invalid_data",
    status_code: "400",
    pointer: [""],
    translations: {
      en: "Check passed expiration date",
      ru: "Проверьте корректность данных",
      uk: "Перевірте корректність даних",
    },
  },

  {
    code: "no_availables_services",
    status_code: "no_availables_services",
    translations: {
      title: {
        en: "No services available for now",
        ru: "Нет доступных сервисов",
        uk: "Наразі немає доступних сервісів",
      },
      details: {
        en: "Please, try again later",
        ru: "Пожалуйста, попробуйте позже",
        uk: "Будь ласка спробуйте пізніше",
      },
    },
  },

  {
    code: "service_unavailable",
    status_code: "service_unavailable",
    translations: {
      title: {
        en: "Selected service is temporary unavailable",
        ru: "Выбранный сервис временно недоступен",
        uk: "Обраний сервіс тимчасово не працює",
      },
      details: {
        en: "Check other service",
        ru: "Попробуйте другой сервис",
        uk: "Спробуйте інший сервіс",
      },
    },
  },
];

const CLIENT_ERRORS = [];

export const DEFAULT_ERROR = {
  code: "400",
  status_code: "400",
  translations: {
    title: {
      en: "Bad request",
      ru: "Неверный запрос",
      uk: "Невірний запит",
    },
    details: {
      en: "Check yout request details.",
      ru: "Проверьте детали вашего запроса.",
      uk: "Перевірте деталі вашого запиту.",
    },
  },
};

export const ERRORS_STRUCT = [].concat(VALIDATION_ERRORS);
